import { escapeHtml } from "./escapeHtml";
import type { PrintLayout } from "./printLayout";
import { resolveHeaderTokens, type HeaderTokenValues } from "./headerTokens";

export function buildHeaderHtml(layout: PrintLayout, tokens: HeaderTokenValues, alt: string): string {
  const text = resolveHeaderTokens(layout.headerHtml, tokens);
  const image = layout.headerImageUrl;
  if (!image && !text.trim()) return "";
  const img = (cls: string) => (image ? `<img class="${cls}" src="${escapeHtml(image)}" alt="${escapeHtml(alt)}" />` : "");
  const textBlock = text.trim() ? `<div class="doc-header__text" style="color:${layout.headerTextColor}">${text}</div>` : "";
  const open = (modifier: string) =>
    `<header class="doc-header doc-header--${modifier}" data-zone="header" style="--doc-logo-h:${layout.headerLogoHeightPx}px">`;

  switch (layout.headerLayout) {
    case "full":
      return image ? `${open("full")}${img("")}</header>` : `${open("inline")}<div class="doc-header__row">${textBlock}</div></header>`;
    case "center":
      return `${open("center")}${img("doc-header__logo")}${textBlock}</header>`;
    case "right":
      return `${open("image-text")}<div class="doc-header__row"><div class="doc-header__split-image">${img("")}</div>${textBlock}</div></header>`;
    case "left":
      return `${open("text-image")}<div class="doc-header__row"><div class="doc-header__split-image">${img("")}</div>${textBlock}</div></header>`;
    case "inline_apart":
      return `${open("inline-apart")}<div class="doc-header__row">${img("doc-header__logo")}${textBlock}</div></header>`;
    case "inline":
    default:
      return `${open("inline")}<div class="doc-header__row">${img("doc-header__logo")}${textBlock}</div></header>`;
  }
}
